import { Alert, Box } from "@mui/material";
import Loader from "components/Loader";
import RedirectBackButton from "components/RedirectBackButton";
import SnackbarMessage from "components/SnackbarMessage";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useState } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { ResponseOfEvaluation } from "services/KnowfullyAdminClient";
import { EvaluationFormMode, SnackbarMessageProps } from "types/common-types";
import EvaluationForm from "./EvaluationForm";

const EvaluationUpdateForm = () => {
  const { formatMessage: t } = useIntl();
  const {
    evaluationsUrl,
    evaluationDetailsUrl,
    evaluationService,
  } = useGlobalContext();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);

  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { isLoading, isError, data } = useQuery<ResponseOfEvaluation>(
    ["evaluation", id],
    () => evaluationService.getEvaluationById(id!),
    {
      enabled: !!id,
    }
  );

  const evaluation = data?.data;
  useTitle(evaluation?.name || t({ id: "evaluationFormUpdateButton" }));

  if (!id) return <Navigate to={evaluationsUrl()} replace />;
  if (isLoading) return <Loader />;
  if (isError) {
    return (
      <Box mt={4}>
        <Alert severity="error">
          <T id="evaluationLoadError" />
        </Alert>
      </Box>
    );
  }

  if (!data?.data) {
    return <Navigate to={evaluationsUrl()} replace />;
  }

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={evaluationDetailsUrl(id)}
          labelKey="backToDetailsButtonLabel"
        />
      </Box>
      <EvaluationForm
        evaluation={evaluation}
        mode={EvaluationFormMode.Update}
        onCancel={() => navigate(evaluationDetailsUrl(id))}
      />
      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </>
  );
};

export default EvaluationUpdateForm;
